import {FC} from 'react';
import {
  ActionIcon,
  CopyButton as _CopyButton,
  rem,
  Tooltip,
} from '@mantine/core';
import {IconCheck, IconCopy} from '@tabler/icons-react';

type CopyButtonProps = {
  value: string;
  timeout?: number;
};

export const CopyButton: FC<CopyButtonProps> = (props) => {
  const {value, timeout = 2000} = props;

  return (
    <_CopyButton value={value} timeout={timeout}>
      {({copied, copy}) => (
        <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
          <ActionIcon
            color={copied ? 'teal' : 'gray'}
            variant="subtle"
            onClick={copy}
          >
            {copied ? (
              <IconCheck style={iconStyle} />
            ) : (
              <IconCopy style={iconStyle} />
            )}
          </ActionIcon>
        </Tooltip>
      )}
    </_CopyButton>
  );
};

const iconStyle = {width: rem(16)};